import { createFileRoute, redirect } from '@tanstack/react-router'
import { useDeviceTimezoneSync } from '@/entities/session'
import { loginUrl } from '@/shared/api'
import { AppShell } from '@/widgets/app-shell'
import { CommandPalette } from '@/widgets/command-palette'

// Pathless-layout аутентифицированной части: хедер+сайдбар. Без session — на
// единый вход хаба (22-unified-login): своей страницы входа у deal нет, поэтому
// это внешний redirect с полной перезагрузкой, а не router-навигация.
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    if (!context.session) {
      throw redirect({ href: loginUrl(`${window.location.origin}${location.href}`) })
    }
  },
  component: AppLayout,
})

// ⌘K-палитра — overlay-виджет, монтируется рядом с AppShell на уровне страницы
// (page→widgets): widget→widget запрещён. Открытие — через стор features/search.
//
// Зона устройства сообщается хабу отсюда: это самый широкий слой, где сессия
// уже гарантированно есть (без неё beforeLoad увёл на вход), и он переживает
// навигацию — запись остаётся одной на загрузку, а не одной на экран.
function AppLayout() {
  useDeviceTimezoneSync()
  return (
    <>
      <AppShell />
      <CommandPalette />
    </>
  )
}
